import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '@sa/core/services/http-client.service';
import { API_ENDPOINTS } from '@sa/shared/constants/api-endpoints';

/**
 * Response returned by the deep-link token resolve endpoint.
 */
export interface DeeplinkResolveResponse {
  /**
   * The raw JSON payload string originally encoded in the legacy `?data=` deep-link.
   * Parsing it yields `{ workspaceItemType, projectdetails }`.
   */
  payload: string;
}

/**
 * Resolves opaque deep-link tokens (used by WAF-safe "Need Review" email links)
 * to their server-side stored JSON payload.
 */
@Injectable({ providedIn: 'root' })
export class DeeplinkService {
  private httpClientService = inject(HttpClientService);

  /**
   * Resolves a deep-link token to its stored JSON payload.
   * @param tenantGuid The tenant GUID that scopes the lookup.
   * @param token The opaque deep-link token to resolve.
   * @returns The stored payload; the endpoint returns 404 for unknown/invalid tokens.
   */
  resolveToken(
    tenantGuid: string,
    token: string
  ): Observable<DeeplinkResolveResponse> {
    return this.httpClientService.get<DeeplinkResolveResponse>(
      API_ENDPOINTS.RESOLVE_DEEPLINK_TOKEN(tenantGuid, token)
    );
  }
}
